import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const viewsResolver: FieldResolver = (metadata: Metadata) =>
  ({ views: metadata.getViews() } as StreamData)

export default viewsResolver
